angular.module('FlexyBeautyApp.services').factory('PaymentDataObject',["SalePaymentType",
    function (SalePaymentType) {
        let PaymentDataObject = function () {
            this.initSalePaymentsPrice();
            this.initSalePaymentsNumber();
        };
        PaymentDataObject.prototype.initSalePaymentsPrice = function () {
            for (let salePaymentType in SalePaymentType) {
                if (SalePaymentType.hasOwnProperty(salePaymentType)) {
                    this[SalePaymentType[salePaymentType].keyPrice] = 0;
                }
            }
        };
        PaymentDataObject.prototype.initSalePaymentsNumber = function () {
            for (let salePaymentType in SalePaymentType) {
                if (SalePaymentType.hasOwnProperty(salePaymentType)) {
                    this[SalePaymentType[salePaymentType].keyNumber] = 0;
                }
            }
        };
        PaymentDataObject.prototype.computeTotalSalePaymentsPrice = function () {
            let price = 0;
            for (let salePaymentType in SalePaymentType) {
                if (SalePaymentType.hasOwnProperty(salePaymentType)) {
                    price += this[SalePaymentType[salePaymentType].keyPrice];
                }
            }
            return price;
        };
        return PaymentDataObject;
    }]);


// WEBPACK FOOTER //
// ./js/services/views/planningPos/PaymentDataObject.js